import jwt from 'jsonwebtoken';

export class JwtHelper {
    private urlBase64Decode(str: string) {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default:
                // tslint:disable-next-line:no-string-throw
                throw 'Illegal base64url string!';
        }
        return decodeURIComponent((<any>window).escape(window.atob(output)));
    }

    public decode(token: string = '') {
        if (token === null || token === '') { return { 'upn': '' }; }
        const parts = token.split('.');
        if (parts.length !== 3) {

            throw new Error('JWT must have 3 parts');
        }
        const decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
            throw new Error('Cannot decode the token');
        }
        return JSON.parse(decoded);
    }

    public signRequest(payload: object = {}) {
        return new Promise(async (resolve, reject) => {
            if (payload === null || payload === {}) { reject('please provide a valid payload'); }
            let token = await jwt.sign(
                payload, 
                process.env.VUE_APP_ACCESS_TOKEN, 
                {
                    expiresIn: '1h'
                }
            );

            resolve(token);
        });
    }
}